import React, { useEffect, useState } from "react";
import AuthService from "../../modules/Admin/services/AuthService";

export default function SessionBootstrap({ children }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    AuthService.restoreSession().finally(() => setReady(true));
  }, []);

  if (!ready) {
    return (
      <div style={{ padding: 48, textAlign: "center", color: "#8392ab", fontSize: 14 }}>
        <i className="fas fa-circle-notch fa-spin me-2" />
        Loading…
      </div>
    );
  }

  return children;
}
